module.exports = __webpack_public_path__ + "media/images/icon__arrow-up-right@3x-5ce6d1be9f349bebfac3e4932c48c271.png";